import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/petitionGuidesArticle/pageContext';

export function PetitionGuidesErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Petition Guides Article page (error: ${error})`);
}
